function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */
import OAuthErrors from '../../../lib/oauth-errors';
import OAuthRelier from '../oauth';
import Vat from '../../../lib/vat';
/*eslint-disable camelcase */

const SUPPLICANT_QUERY_PARAM_SCHEMA = {
  access_type: Vat.accessType().renameTo('accessType'),
  client_id: Vat.clientId().required().renameTo('clientId'),
  code_challenge: Vat.codeChallenge().required().renameTo('codeChallenge'),
  code_challenge_method: Vat.codeChallengeMethod().required().renameTo('codeChallengeMethod'),
  keys_jwk: Vat.keysJwk().required().renameTo('keysJwk'),
  redirect_uri: Vat.url() // redirect URI is not required for OAuth flows,
  // we only validate it in the OAuth broker if it is provided
  // See `isCorrectRedirect` app/scripts/models/reliers/oauth.js
  .renameTo('redirectUri'),
  scope: Vat.string().required().min(1),
  state: Vat.string().required()
};
const SUPPLICANT_HASH_PARAMETER_SCHEMA = {
  channel_id: Vat.channelId().required().renameTo('channelId'),
  channel_key: Vat.channelKey().required().renameTo('channelKey')
};
/*eslint-enable camelcase */

let SupplicantRelier = /*#__PURE__*/function (_OAuthRelier) {
  _inherits(SupplicantRelier, _OAuthRelier);

  var _super = _createSuper(SupplicantRelier);

  function SupplicantRelier() {
    var _this;

    _classCallCheck(this, SupplicantRelier);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "name", 'pairing-supplicant');

    return _this;
  }

  _createClass(SupplicantRelier, [{
    key: "fetch",
    value: function fetch() {
      return Promise.resolve().then(() => {
        this.importHashParamsUsingSchema(SUPPLICANT_HASH_PARAMETER_SCHEMA, OAuthErrors);
        this.importSearchParamsUsingSchema(SUPPLICANT_QUERY_PARAM_SCHEMA, OAuthErrors);
        return this._setupOAuthRPInfo();
      });
    }
  }, {
    key: "getOAuthParams",
    value: function getOAuthParams() {
      const scopes = this.scopeStrToArray(this.get('scope')).join(' ');
      return {
        /*eslint-disable camelcase*/
        access_type: this.get('accessType'),
        client_id: this.get('clientId'),
        code_challenge: this.get('codeChallenge'),
        code_challenge_method: this.get('codeChallengeMethod'),
        keys_jwk: this.get('keysJwk'),
        scope: scopes,
        state: this.get('state')
        /*eslint-enable camelcase*/

      };
    }
  }, {
    key: "validateApprovalData",
    value: function validateApprovalData(approvalData) {
      const code = approvalData.code,
            state = approvalData.state;

      if (Vat.oauthCode().validate(code).error) {
        throw OAuthErrors.toInvalidParameterError('code');
      }

      if (state !== this.get('state')) {
        throw OAuthErrors.toInvalidParameterError('state');
      }
    }
  }]);

  return SupplicantRelier;
}(OAuthRelier);

export { SupplicantRelier as default };